mainApp.component('eventsRedirect', {
    // redirect for legacy event mails, should be removed when moving to new fe and after ENG-15585 is merged
    controller: function($state, DiscoveryQueryService, DateRangeService) {
        const ctrl = this;

        ctrl.$onInit = function () {
            ctrl.formatterForType = {
                date: function(value) {
                    return $filter('date')(value, 'yyyy/MM/dd HH:mm:ss.sss');
                },
                arrayOfKeywords: function(value) {
                    return value.join(', ');
                }
            }

            ctrl.cdr = DateRangeService.getCopyOfCurrentDateRange(1);

            ctrl.fetchSpec(function () {
                $state.go('app.eventsDiscovery', angular.extend({
                    start: ctrl.cdr.from.getTime(),
                    end: new Date(ctrl.cdr.to).getTime() + 1000 * 60 * 2, // at least two minutes range
                    query: ctrl.generateQuery(),
                    queryChanged: true,
                    selectedFields: ['time', 'event_data'],
                }, {}));
            });
        }

        ctrl.generateQuery = function () {
            const query = [];

            if ($state.params.internalId) {
                query.push(ctrl.getFilterObject('internalId', 'in',
                    angular.fromJson($state.params.internalId.replace('[', '["').replace(']', '"]').replace(/,/g, '","').replace(/\s/g, ''))));
            }

            if ($state.params.ruleType) {
                query.push({
                    field: 'event_sub_type',
                    operator: 'is',
                    spec: 'mustMatchPhrase',
                    value: $state.params.ruleType,
                    description: "event sub type is " + $state.params.ruleType
                });
            }

            if ($state.params.ruleId) {
                query.push({
                    field: 'rule_id',
                    operator: 'is',
                    spec: 'mustMatchPhrase',
                    value: $state.params.ruleId,
                    description: "rule id is " + $state.params.ruleId
                });
            }

            return angular.toJson(query);
        }

        ctrl.fetchSpec = function(onSuccess) {
            store.fetch({
                method: 'POST',
                path: '/discoverSpec/events?accountId=' + $state.params.accountId,
                success: function(data) {
                    ctrl.fieldsSpec = data;

                    onSuccess();
                }
            });
        }

        ctrl.getFilterObject = function(field, operator, value) {
            const operatorDef = DiscoveryQueryService.getOperatorDefinition(operator);

            return {
                field: field,
                operator: operator,
                spec: operatorDef.spec,
                value: value,

                description: ctrl.fieldsSpec[field].presentation + ' ' + operatorDef.descriptor  + ' ' + ctrl.getPresentationValue(field, operatorDef, value)
            };
        }

        ctrl.getPresentationValue = function(field, operatorDef, value) {
            if (operatorDef.type === 'value') {
                return ctrl.fieldValueFormatter(field, value);
            }

            if (operatorDef.type === 'list') {
                return '[' + value.map(v => ctrl.fieldValueFormatter(field, v)).join(', ') + ']';
            }

            if (operatorDef.type === 'range') {
                return ctrl.fieldValueFormatter(field, value.from) + ' and ' + ctrl.fieldValueFormatter(field, value.to);
            }

            if (operatorDef.type === 'boolean') {
                return '';
            }
        }

        ctrl.fieldValueFormatter = function(field, value) {
            if (Array.isArray(value))
                return ctrl.formatterForType.arrayOfKeywords(value);
            return (field !== '_source' && field !== 'alert' && ctrl.formatterForType[ctrl.fieldsSpec[field].type] && ctrl.formatterForType[ctrl.fieldsSpec[field].type](value)) || value;
        }
    }
});